module.exports = __webpack_public_path__ + "static/media/Aloha-Mundo.36196799.webm";